// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"86":"6e9bf52a","127":"b487ebbf","137":"3086805c","236":"24d84699","380":"666c8f28","426":"44a76664","443":"be46db18","529":"a264a886","556":"5e0f4cf6","614":"01850b5e","717":"22fd1825","955":"36b481de"}[chunkId] + ".js";
};